import React, { useState } from 'react';
import { toast } from 'react-toastify';
import Loader from '../../components/Loader';
import PortalApiService from '../../services/PortalApiService';
import PortalAuthService from '../../services/PortalAuthService';

const Row = ({ label, children }) => (
    <div className="col-lg-6 mb-6">
        <label className="fs-6 fw-semibold mb-1 d-block text-muted">{label}</label>
        <span className="fs-6 text-gray-800">{children || 'N/A'}</span>
    </div>
);

const PortalProfile = () => {
    const company = PortalAuthService.getCurrentUser();
    const isFacility = company?.type === 'facility';
    const [passwords, setPasswords] = useState({ old_password: '', new_password: '', confirm_password: '' });
    const [isSaving, setIsSaving] = useState(false);

    const changePassword = async (e) => {
        e.preventDefault();
        if (passwords.new_password !== passwords.confirm_password) {
            toast.error('New password and confirm password do not match');
            return;
        }
        try {
            setIsSaving(true);
            const { data } = await PortalApiService.request({ method: 'POST', url: '/changePassword', data: passwords });
            if (data.status) {
                toast.success(data.message);
                setPasswords({ old_password: '', new_password: '', confirm_password: '' });
            } else {
                toast.error(data.message);
            }
        } catch (error) {
            // PortalApiService already shows the error toast
        } finally {
            setIsSaving(false);
        }
    };

    return (
        <div className="d-flex flex-column flex-column-fluid">
            <div className="app-toolbar py-3 py-lg-6">
                <div className="app-container container-xxl">
                    <h1 className="page-heading text-dark fw-bold fs-3 my-0">Profile</h1>
                </div>
            </div>
            <div className="app-content flex-column-fluid">
                <div className="app-container container-xxl">
                    <div className="card mb-5">
                        <div className="card-body p-9">
                            <div className="d-flex align-items-center mb-8">
                                <div className="symbol symbol-80px symbol-circle me-6">
                                    <img src={company?.picture} alt={company?.name} />
                                </div>
                                <div>
                                    <h3 className="fw-bold mb-1">{company?.name}</h3>
                                    <div className="text-muted">{company?.email}</div>
                                </div>
                            </div>
                            <div className="row">
                                <Row label="Phone">{company?.phone ? `${company.phone_code || ''} ${company.phone}` : null}</Row>
                                <Row label="License No.">{company?.license_no}</Row>
                                <Row label="Website">{company?.website}</Row>
                                <Row label="Location">{company?.location}</Row>
                                {isFacility && (
                                    <div className="col-lg-12 mb-6">
                                        <label className="fs-6 fw-semibold mb-1 d-block text-muted">Service Areas</label>
                                        {(company.areas || []).map(a => (
                                            <span key={a} className="badge badge-light-success fs-7 me-2 mb-2">{a}</span>
                                        ))}
                                    </div>
                                )}
                            </div>
                            <div className="form-text">To change these details, contact the Helpio admin.</div>
                        </div>
                    </div>

                    <div className="card">
                        <div className="card-header">
                            <h3 className="card-title fw-bold">Change Password</h3>
                        </div>
                        <div className="card-body">
                            <form onSubmit={changePassword} className="row">
                                {[
                                    ['old_password', 'Current Password'],
                                    ['new_password', 'New Password'],
                                    ['confirm_password', 'Confirm Password'],
                                ].map(([key, label]) => (
                                    <div className="col-md-4 mb-5" key={key}>
                                        <label className="form-label required">{label}</label>
                                        <input type="password" className="form-control" required minLength={key === 'old_password' ? undefined : 6}
                                            value={passwords[key]} onChange={e => setPasswords({ ...passwords, [key]: e.target.value })} />
                                    </div>
                                ))}
                                <div className="col-12 text-end">
                                    <button type="submit" className="btn btn-primary" disabled={isSaving}>
                                        {isSaving ? <Loader size="20" text="Saving" color="white" /> : 'Update Password'}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PortalProfile;
